import {localize} from 'config/Language';

export function LoaderView() {
  return <div>{localize('LOADING')}...</div>;
}
